import * as React from "react";
import { COLOR } from "utils/variables";
import "myshubhlife-component/inputTextField/index.scss";

interface IRadioButton {
    name: string;
    value: string | number;
    fieldName?: string;
    checked?: boolean;
    iconUrl?: string;
}

interface IRadioButtonProps {
    buttonList: IRadioButton[];
    value: string | number;
    label?: string;
    fieldName: string;
    errorMsg?: string;
    onChangeHandler?: (index: number, fieldName: string, value: string | number) => void;
    index?: number;
    disabled?: boolean;
    activeColor?: COLOR;
    iconUrl?: string;
    isRequired?: boolean;
    tooltipLabel?: string;
}

const RadioButtonField = (props: IRadioButtonProps) => {
    const containerStyle = {
        padding: 2,
        margin: 3,
        fontSize: 15,
        fontWeight: 500,
    };
    const buttonStyle = {
        border: `1px solid ${COLOR.GRAY}`,
        color: COLOR.BLACK,
        padding: 5,
        margin: ".5%",
        display: "inline-block",
        borderRadius: 3,
        width: "49%",
        background: COLOR.WHITE,
        minHeight: 40,
        cursor: props.disabled ? "not-allowed" : "pointer",
    };
    const errorMsgStyle = {
        color: COLOR.RED,
        fontSize: 13,
        paddingLeft: 3,
    };
    return (
        <div style={containerStyle}>
            <div className="label-wrapper">
            {props.label ?
                <div className="label">
                    {props.label}
                </div> : null}
                {!props.isRequired && <span className="form-optional">Optional</span>}
                {props.tooltipLabel && 
                  <div className="form-tooltip">
                    <span className="form-tooltiptext form-tooltip-right">{props.tooltipLabel}</span>
                  </div>
                }
            </div>
            <div>
            {props.buttonList.map((item, index) => {
                    let inputStyle = buttonStyle;
                    if (item.value === props.value) {
                        inputStyle = {
                            ...buttonStyle,
                            background: props.activeColor ? props.activeColor : COLOR.PRIMARY,
                            color: COLOR.WHITE,
                        };
                    }
                    return (
                        <button
                            style={inputStyle}
                            disabled={props.disabled}
                            key={index}
                            type="button"
                            onClick={() => props.onChangeHandler(props.index, props.fieldName, item.value)}
                        >
                            {item.iconUrl &&
                            <div>
                                <img src={item.iconUrl} alt="icon" width="30" height="30"/>
                            </div> }
                            {item.name}
                        </button>
                    );
                })}
            </div>
            {props.errorMsg &&
            <div style={errorMsgStyle}>
                {props.errorMsg}
            </div>}
        </div>
    );
};

RadioButtonField.defaultProps = {
  isRequired: true
}
export default RadioButtonField;
